import {
  BsCalendar,
  BsCalendarCheck,
  BsChatLeftText,
  BsChatLeftTextFill,
  BsCheckCircleFill,
  BsCurrencyDollar,
  BsEye,
  BsEyeSlash,
  BsFillBookmarkStarFill,
  BsFillSearchHeartFill,
  BsGeoAlt,
  BsInfoCircle,
  BsSearch,
  BsSend,
  BsSendFill,
  BsSendSlash,
  BsTag,
  BsTools,
  BsHeart,
  BsHeartFill,
  BsStarFill,
  BsCheckCircle,
  BsFillCheckCircleFill,
  BsPlusCircle,
  BsChatLeft,
  BsThreeDotsVertical,
  BsThreeDots,
  BsCheck,
} from 'react-icons/bs';
import { GrMapLocation, GrShare } from 'react-icons/gr';
import {
  AiFillFire,
  AiFillInsurance,
  AiFillSafetyCertificate,
} from 'react-icons/ai';
import {
  RiAuctionFill,
  RiAuctionLine,
  RiHomeSmileFill,
  RiWalkLine,
} from 'react-icons/ri';
import {
  TbMailbox,
  TbRulerMeasure,
  TbMapPin,
  TbPencil,
  TbHome,
  TbLogout,
  TbLock,
  TbPlus,
  TbTrash,
  TbChevronLeft,
  TbChevronRight,
  TbChevronUp,
  TbChevronDown,
  TbShovel,
  TbRoad,
  TbNumbers,
  TbSum,
  TbWindow,
  TbToolsKitchen,
  TbHomePlus,
  TbPigMoney,
  TbGraph,
  TbMenu,
  TbLayoutGrid,
  TbLayoutList,
  TbLayoutKanban,
  TbArrowLeft,
  TbArrowRight,
  TbBuildingStore,
  TbInfoCircle,
  TbMap,
  TbBuildingCommunity,
  TbElevator,
  TbWorld,
  TbShare2,
  TbMapPinFilled,
  TbExternalLink,
  TbDeviceTv,
  TbSnowflake,
  TbHomeCheck,
} from 'react-icons/tb';
import { BsHouseHeart } from 'react-icons/bs';
import { TiStarFullOutline } from 'react-icons/ti';
import { LuBuilding, LuUtilityPole } from 'react-icons/lu';
import {
  MdApartment,
  MdArchitecture,
  MdBalcony,
  MdBed,
  MdBrush,
  MdChecklist,
  MdCleaningServices,
  MdClear,
  MdComment,
  MdConstruction,
  MdDateRange,
  MdDoorFront,
  MdEdit,
  MdElectricalServices,
  MdElevator,
  MdEmail,
  MdFavorite,
  MdFireplace,
  MdHomeWork,
  MdHouse,
  MdLocalLaundryService,
  MdNaturePeople,
  MdOtherHouses,
  MdOutlineHomeWork,
  MdOutlineLocationCity,
  MdOutlineSell,
  MdOutlineShield,
  MdOutlineSpaceDashboard,
  MdPeople,
  MdPower,
  MdPowerInput,
  MdRoofing,
  MdSave,
  MdSell,
  MdWaterDrop,
  MdYard,
} from 'react-icons/md';
import { FiLogIn, FiMap, FiMapPin } from 'react-icons/fi';
import { BsPersonFillCheck } from 'react-icons/bs';
import {
  BiHomeHeart,
  BiSolidCarGarage,
  BiSolidHomeHeart,
  BiSolidQuoteAltLeft,
  BiSolidUserCircle,
  BiSolidWine,
  BiUserCircle,
} from 'react-icons/bi';
import { GoHome, GoHomeFill } from 'react-icons/go';
import {
  FaBath,
  FaBeer,
  FaBox,
  FaBriefcase,
  FaCoins,
  FaCouch,
  FaFan,
  FaHome,
  FaMagic,
  FaMoneyBillWave,
  FaPhone,
  FaRegCalendarAlt,
  FaRegCalendarCheck,
  FaRegClock,
  FaSearch,
  FaToilet,
  FaExpandAlt,
} from 'react-icons/fa';
import {
  FaBell,
  FaHouseFlag,
  FaKitchenSet,
  FaMasksTheater,
  FaPencil,
  FaPeopleRoof,
  FaRegHandshake,
} from 'react-icons/fa6';
import { HiBadgeCheck, HiFlag } from 'react-icons/hi';
import { RxUpdate } from 'react-icons/rx';
import {
  IoBed,
  IoLibrary,
  IoShieldCheckmark,
  IoShieldOutline,
  IoTimerOutline,
  IoTrashSharp,
} from 'react-icons/io5';
import {
  GiBrickWall,
  GiBrokenWall,
  GiCampfire,
  GiHanger,
  GiMetalBar,
  GiStonePath,
  GiTap,
  GiWoodBeam,
} from 'react-icons/gi';
import {
  PiCoatHanger,
  PiGarageBold,
  PiOfficeChairFill,
  PiPolygonFill,
  PiRoadHorizon,
  PiSuitcaseSimple,
  PiSuitcaseSimpleFill,
} from 'react-icons/pi';
import { ImUserTie } from 'react-icons/im';
import { IoMdChatboxes } from 'react-icons/io';

const additionalIcons = {
  OFFICE: TbBuildingStore,
  OFFICE_BUILDING: LuBuilding,
  CURRENCY: BsCurrencyDollar,
  PRICE_TAG: BsTag,
  LOCATION: BsGeoAlt,
  LOCATION_PIN: TbMapPinFilled,
  LOCATION_CITY: MdOutlineLocationCity,
  DATE: BsCalendar,
  DATE_RANGE: MdDateRange,
  TIME: FaRegClock,
  CALENDAR: FaRegCalendarAlt,
  CALENDAR_CHECK: FaRegCalendarCheck,
  INFO: BsInfoCircle,
  INFO_CIRCLE: TbInfoCircle,
  MAP: TbMap,
  MAP_BUTTON: FiMap,
  BRIEFCASE: FaBriefcase,
  MONEY: FaMoneyBillWave,
  COMMUNITY: TbBuildingCommunity,
};

export const ICONS = {
  HOME: TbHome,
  MENU: TbMenu,
  PROJECT: TbHomeCheck,
  USP: MdHomeWork,
  SELL: MdOutlineSell,
  SELL_ACTIVE: MdSell,
  BUY: BiHomeHeart,
  BUY_ACTIVE: BiSolidHomeHeart,
  SEARCH: BsSearch,
  SEARCH_ACTIVE: BsFillSearchHeartFill,
  VALUATION: TbGraph,
  LETTER: TbMailbox,
  LETTER_SENT: BsCheckCircleFill,
  BID: RiAuctionLine,
  BID_ACTIVE: RiAuctionFill,
  MY_HOMES: GoHome,
  MY_HOMES_ACTIVE: GoHomeFill,
  BROKER: PiSuitcaseSimple,
  BROKER_ACTIVE: PiSuitcaseSimpleFill,
  MAIL: MdEmail,
  PHONE: FaPhone,
  EXPORT: TbShare2,
  SHARE: GrShare,
  CHAT: BsChatLeftText,
  CHAT2: BsChatLeft,
  CHAT_ACTIVE: BsChatLeftTextFill,
  CHAT_INPUT: BsSend,
  CHAT_INPUT_HOVER: BsSendFill,
  CHAT_INPUT_DISABLED: BsSendSlash,
  SMS: IoMdChatboxes,
  REALTOR: BsHouseHeart,
  CATEGORY: MdOutlineHomeWork,
  CATEGORY_ACTIVE: MdHomeWork,
  TENURE: BsTag,
  PLOT_SIZE: MdNaturePeople,
  LIVING_SPACE: TbRulerMeasure,
  ADDITIONAL_SPACE: TbHomePlus,
  ROOMS: MdOutlineSpaceDashboard,
  BEDROOMS: MdBed,
  BUILD_YEAR: TbShovel,
  PROPERTY_DESIGNATION: TbNumbers,
  PRICE: TbPigMoney,
  MONTHLY_FEE: TbPigMoney,
  STREET: TbRoad,
  ZIP: GrMapLocation,
  CITY: TbMapPin,
  ABOUT: RiHomeSmileFill,
  NEIGHBOURHOOD: FiMapPin,
  ADD_HOME: TbPlus,
  PREVIEW_HOME: TbExternalLink,
  EDIT_HOME: TbPencil,
  EDIT_HOME_LOCKED: TbLock,
  EDIT_INFO: MdEdit,
  SAVE: MdSave,
  VERIFY: IoShieldCheckmark,
  BANKID: MdOutlineShield,
  CHECK: BsCheck,
  CLOSE: MdClear,
  EXPAND: FaExpandAlt,
  FLOOR: MdElevator,
  OPEN_HOME: TbHome,
  REMOVE_HOME: TbTrash,
  ADD_HOMEBUYERS: TbPlus,
  EDIT_HOMEBUYERS: TbPencil,
  OPEN_BUYERS: BiHomeHeart,
  REMOVE_BUYERS: TbTrash,
  SEARCHES: BiHomeHeart,
  SEARCHES_ACTIVE: BiSolidHomeHeart,
  BUYERS: FaPeopleRoof,
  BUYERS_ACTIVE: BiSolidHomeHeart,
  BUYERS_MATCH: BsPersonFillCheck,
  BUYER_MATCH_PERCENTAGE: FaRegHandshake,
  BUYER_ACTIVITY_TIME: IoTimerOutline,
  SHOW_DETAILS: BsEye,
  HIDE_DETAILS: BsEyeSlash,
  ACCOUNT: BiUserCircle,
  ACCOUNT_ACTIVE: BiSolidUserCircle,
  GENERATE_INPUTS: FaMagic,
  CURATED: MdHomeWork,
  SEARCH_HISTORY: FaSearch,
  SEARCH_HISTORY_DEFAULT: FaHome,
  REMOVE_SEARCH_HISTORY: TbTrash,
  LOGOUT: TbLogout,
  CLAIMED: HiBadgeCheck,
  UPDATED: RxUpdate,
  NEW: BsFillBookmarkStarFill,
  STATUS: HiFlag,
  HOMEBUYERS_ALERT: FaBell,
  EDIT_SEARCH: FaPencil,
  FEATURES: TiStarFullOutline,
  NEARBY: RiWalkLine,
  RENTAL_UNIT: MdApartment,
  PREVIOUS: TbChevronLeft,
  NEXT: TbChevronRight,
  UP: TbChevronUp,
  DOWN: TbChevronDown,
  QUOTE: BiSolidQuoteAltLeft,
  WISHLIST: BsHeart,
  WISHLIST_ACTIVE: BsHeartFill,
  INTEREST: BsCheckCircle,
  INTEREST_ACTIVE: BsFillCheckCircleFill,
  FIRE: AiFillFire,
  STAR: BsStarFill,
  UPLOAD_HOME_IMAGE: BsPlusCircle,
  OPTIONS: BsThreeDotsVertical,
  MORE: BsThreeDots,
  ARCHITECT: MdArchitecture,
  LOGIN: FiLogIn,
  OPERATING_COSTS: {
    WATER: MdWaterDrop,
    ELECTRICITY_CONSUMPTION: MdPower,
    ELECTRICITY: MdElectricalServices,
    HEATING: MdFireplace,
    SANITATION: IoTrashSharp,
    ROAD: PiRoadHorizon,
    MAINTENANCE: MdConstruction,
    CHIMNEY: MdCleaningServices,
    INSURANCE: AiFillSafetyCertificate,
    INSURANCE_FULL_VALUE: AiFillInsurance,
    PROPERTY_TAX: MdHouse,
    OTHER: FaCoins,
    SUM: TbSum,
    PEOPLE: MdPeople,
    COMMENT: MdComment,
  },
  BUILDING: {
    CATEGORY: MdHomeWork,
    YEAR: TbShovel,
    COMMENT_FOR_YEAR: MdComment,
    FACADE: GiBrokenWall,
    FRAME: LuUtilityPole,
    WINDOWS: TbWindow,
    INSULATED: TbSnowflake,
    ELEVATOR: TbElevator,
    INTERNET: TbWorld,
    TV: TbDeviceTv,
    BUILDING_TYPE: MdOtherHouses,
    BEAM: GiWoodBeam,
    EXTERNALLY_SHEET_METAL_WORK: GiMetalBar,
    FOUNDATION_WALL: GiBrickWall,
    ROOF: MdRoofing,
    FOUNDATION: GiStonePath,
    HEATING: MdFireplace,
    OTHER: MdComment,
    OTHER_BUILDINGS: PiGarageBold,
    RENOVATIONS: MdBrush,
    WATER: GiTap,
    VENTILATION: FaFan,
    ENERGY_CONSUMPTION: MdPower,
    ENERGY_CLASSIFICATION: MdChecklist,
    PLOT_SIZE: MdNaturePeople,
    PLOT_TYPE: MdYard,
    PLOT_OTHER: MdOutlineSpaceDashboard,
    PLOT_PARKING: BiSolidCarGarage,
    PLOT_PATIO: MdNaturePeople,
    PLOT_BUILDING_PERMISSION: MdOutlineSpaceDashboard,
  },
  ROOM_DESCRIPTIONS: {
    KITCHEN: FaKitchenSet,
    LIVING_ROOM: FaCouch,
    BEDROOM: IoBed,
    BATHROOM: FaBath,
    HALLWAY: PiCoatHanger,
    BALCONY: MdBalcony,
    STORAGE: FaBox,
    OTHER: MdOutlineSpaceDashboard,
    LAUNDRY_ROOM: MdLocalLaundryService,
    OFFICE: PiOfficeChairFill,
    LIBRARY: IoLibrary,
    DINING_ROOM: TbToolsKitchen,
    SAUNA: GiCampfire,
    TOILET: FaToilet,
    BAR: FaBeer,
    SOCIAL_ROOM: FaMasksTheater,
    DINING_HALL: BiSolidWine,
    GARDEN: MdYard,
    TERRACE: MdNaturePeople,
    WALK_IN_CLOSET: GiHanger,
    CARPORT: BiSolidCarGarage,
    ENTRANCE: MdDoorFront,
    RENOVATIONS: BsTools,
  },
  TABS: {
    DEFAULT: {
      CURATIONS: MdFavorite,
      SEARCH_PROFILES: MdFavorite,
      SEARCH_HISTORY: FaSearch,
    },
    MAIN: {
      HOMES: MdHomeWork,
      BUYERS: FaPeopleRoof,
      BROKERS: ImUserTie,
      AREAS: PiPolygonFill,
      MUNICIPALITIES: TbBuildingCommunity,
    },
  },
  VIEWS: {
    GRID: TbLayoutGrid,
    LIST: TbLayoutList,
    KANBAN: TbLayoutKanban,
  },
  ARROWS: {
    LEFT: TbArrowLeft,
    RIGHT: TbArrowRight,
  },
  CHEVRONS: {
    UP: TbChevronUp,
    DOWN: TbChevronDown,
    LEFT: TbChevronLeft,
    RIGHT: TbChevronRight,
  },
  ...additionalIcons,
};
